/* eslint-disable no-useless-escape */
<template>
  <div>
    <errorDialog :mainColor="mainColor" v-model="error"></errorDialog>

    <div v-if="$vuetify.breakpoint.smAndDown">
      <div>
        <!-- if display employee -->
        <template v-if="isEmployee">
          <v-form v-model="valid" :ref="personType + childIndex.toString()">
            <v-container fluid>
              <v-flex xs12>
                <span class="commonFont" style="color: #00558c">
                  Over the next few screens we will be asking questions about
                  you and those you wish to seek coverage on (if applicable).
                  <br />Please include any children you wish to cover on a child
                  rider.
                </span>
              </v-flex>
              <br />
              <br />

              <v-flex xs11>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="Employee First Name"
                  v-capitalizeName="firstName"
                  ref="employeeName"
                  v-if="!isAgentApplication"
                  readonly
                ></v-text-field>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="Employee First Name"
                  v-capitalizeName="firstName"
                  ref="employeeName"
                  v-if="isAgentApplication"
                ></v-text-field>
              </v-flex>
              <v-flex xs11>
                <v-text-field
                  v-model="middleName"
                  label="Employee Middle Name"
                  v-capitalizeName="middleName"
                  readonly
                  v-if="!isAgentApplication"
                  >></v-text-field
                >
                <v-text-field
                  v-model="middleName"
                  label="Employee Middle Name"
                  v-capitalizeName="middleName"
                  v-if="isAgentApplication"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs11>
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Employee Last Name"
                  v-capitalizeName="lastName"
                  readonly
                  v-if="!isAgentApplication"
                  >></v-text-field
                >
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Employee Last Name"
                  v-capitalizeName="lastName"
                  v-if="isAgentApplication"
                  >></v-text-field
                >
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  v-model.trim="street"
                  label="Residence Address"
                  :rules="residenceRules"
                  v-capitalize="street"
                  ref="empAddr"
                  v-on:keyup.enter="gotoField('empEmail', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  v-model.trim="homePhone"
                  label="Primary Phone"
                  :rules="phoneRules"
                  ref="empPhone"
                  v-on:keyup.enter="gotoField('empWrkPhone', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  v-model.trim="workPhone"
                  label="Work Phone"
                  :rules="phoneRules2"
                  ref="empWrkPhone"
                  v-on:keyup.enter="gotoField('empCity', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  v-model.trim="city"
                  label="City"
                  :rules="cityRules"
                  v-capitalize="city"
                  ref="empCity"
                  v-on:keyup.enter="gotoField('empState', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs11>
                <v-select
                  v-model="state"
                  :items="states"
                  menu-props="auto"
                  label="Select State"
                  single-line
                  attach
                  :rules="stateRules"
                  ref="empState"
                  v-on:blur="gotoField('zipEmp', $event)"
                ></v-select>
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  ref="zipEmp"
                  v-model.trim="zip"
                  :rules="zipRules"
                  label="ZIP"
                  v-on:keyup.enter="gotoField('empDOB', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs11>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model.trim="email"
                      :rules="emailRules"
                      label="E-Mail"
                      v-on="on"
                      ref="empEmail"
                      v-on:keyup.enter="gotoField('empPhone', $event)"
                    ></v-text-field>
                  </template>
                  <span>Documents will be sent to the e-mail provided.</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs11>
                <!-- <v-dialog ref="dialog" v-model="modal" persistent full-width width="290px"> -->
                <!-- <v-menu
                  v-model="menu2small"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  ref="menu2small"
                >
                <template v-slot:activator="{ on }">-->
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2small = false"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  v-fixDate="birthdate"
                  ref="empDOB"
                  readonly
                  v-if="!isAgentApplication"
                ></v-text-field>
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2small = false"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  v-fixDate="birthdate"
                  ref="empDOB"
                  v-if="isAgentApplication"
                ></v-text-field>

                <!-- </template> -->
                <!-- <v-date-picker
                    no-title
                    v-model="parsedBirthdate"
                    :rules="[rules.required]"
                    scrollable
                    color="green"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @input="menu2small = false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="menu2small=false" :color="mainColor" dark>Cancel</v-btn>
                    <v-btn text @click="$refs.menu2small.save(birthdate)" :color="mainColor" dark>OK</v-btn>
                </v-date-picker>-->
                <!-- </v-menu> -->
              </v-flex>

              <v-flex xs11>
                <v-radio-group
                  v-model="sex"
                  row
                  label
                  :rules="genderRules"
                  ref="empSex"
                  v-on:keyup.tab.enter="gotoField('empEmployerName', $event)"
                >
                  <v-radio label="Male" value="M" :color="mainColor"></v-radio>
                  <v-radio
                    label="Female"
                    value="F"
                    :color="mainColor"
                  ></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  v-model.trim="employer"
                  label="Employer"
                  ref="empEmployerName"
                  disabled="disabled"
                  v-on:keyup.enter="gotoField('empEmployerCity', $event)"
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs11>
                <v-text-field
                  v-model.trim="employerCity"
                  label="Employer's City"
                  :rules="employerCityRules"
                  v-capitalize="employerCity"
                  ref="empEmployerCity"
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs11>
                <v-select
                  v-model="employerState"
                  :items="states"
                  menu-props="auto"
                  label="Select Employer State"
                  single-line
                  attach
                  disabled="disabled"
                  :rules="employerStateRules"
                  ref="empEmployerState"
                  v-on:blur="gotoBeneRadioBtns($event)"
                ></v-select>
                <!-- <v-select
                  v-model="employerState"
                  :items="states"
                  menu-props="auto"
                  label="Select Employer State"
                  single-line
                  attach
                  v-if="isAgentApplication"
                  :rules="employerStateRules"
                  ref="empEmployerState"
                  v-on:blur="gotoBeneRadioBtns($event)"
                ></v-select> -->
              </v-flex>

              <v-flex xs11>
                <v-radio-group
                  v-model="beneRadioBtn"
                  label="Beneficiary"
                  ref="beneEmployee"
                  :rules="otherBeneRules"
                  v-on:keyup.tab.enter="gotoNextFieldBene('otherBene', $event)"
                >
                  <v-radio
                    label="Spouse"
                    value="spouse"
                    :color="mainColor"
                    ref="spouseBeneLabel"
                  ></v-radio>
                  <v-radio
                    label="Other"
                    value="other"
                    :color="mainColor"
                    ref="otherBeneLabel"
                  ></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs11>
                <v-text-field
                  v-model.trim="otherBene"
                  :error-messages="otherBeneRule"
                  label="Other Beneficiary"
                  :disabled="beneRadioBtn === 'spouse'"
                  ref="otherBene"
                ></v-text-field>
              </v-flex>
            </v-container>
          </v-form>
        </template>
        <!-- if display spouse -->
        <template v-else-if="isSpouse">
          <v-form v-model="valid" :ref="personType + childIndex.toString()">
            <v-container fluid>
              <v-flex xs12>
                <v-checkbox
                  v-model="NA"
                  label="Not Applicable"
                  :color="mainColor"
                ></v-checkbox>
              </v-flex>
              <br />
              <!-- <v-flex xs12>
                <v-text-field
                  v-model.trim="name"
                  :rules="nameRules"
                  label="Spouse's Full Name"
                  v-if="!NA"
                  v-capitalizeName="name"
                  ref="spouseName"
                  v-on:keyup.enter="gotoField('spouseEmail', $event)"
                ></v-text-field>
              </v-flex>-->

              <v-flex xs12>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="Spouse First Name"
                  v-capitalizeName="firstName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="middleName"
                  label="Spouse Middle Name"
                  v-capitalizeName="middleName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Spouse Last Name"
                  v-capitalizeName="lastName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model.trim="email"
                  :rules="emailRules"
                  label="E-Mail"
                  v-if="!NA"
                  ref="spouseEmail"
                  v-on:keyup.enter="gotoField('spouseDOB', $event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <!-- <v-menu
                  v-model="menu2small"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  v-if="!NA"
                  ref="menu2small"
                >
                <template v-slot:activator="{ on }">-->
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2small = false"
                  v-fixDate="birthdate"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  v-if="!NA"
                  ref="spouseDOB"
                ></v-text-field>
                <!-- </template> -->
                <!-- <v-date-picker
                    no-title
                    v-model="parsedBirthdate"
                    :rules="[rules.required]"
                    scrollable
                    color="green"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @input="menu2small = false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="menu2small = false" :color="mainColor" dark>Cancel</v-btn>
                    <v-btn text @click="$refs.menu2small.save(birthdate)" :color="mainColor" dark>OK</v-btn>
                </v-date-picker>-->
                <!-- </v-menu> -->
              </v-flex>
              <v-flex xs12>
                <v-radio-group
                  v-model="sex"
                  row
                  label
                  v-if="!NA"
                  :rules="genderRules"
                  ref="spouseSex"
                >
                  <v-radio label="Male" value="M" :color="mainColor"></v-radio>
                  <v-radio
                    label="Female"
                    value="F"
                    :color="mainColor"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-container>
          </v-form>
        </template>
        <!-- if display child -->
        <template v-else-if="isChild">
          <v-form v-model="valid" :ref="personType + childIndex.toString()">
            <v-container fluid>
              <v-flex xs12>
                <v-checkbox
                  v-model="NA"
                  label="Not Applicable"
                  :color="mainColor"
                ></v-checkbox>
              </v-flex>
              <br />
              <!-- <v-flex xs12>
                <v-text-field
                  v-model.trim="name"
                  :rules="nameRules"
                  label="Child's Full Name"
                  v-if="!NA"
                  v-capitalizeName="name"
                  :ref="'childName'+childIndex.toString()"
                  v-on:keyup.enter="gotoField('childEmail' + childIndex.toString(), $event)"
                ></v-text-field>
              </v-flex>-->

              <v-flex xs12>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="Child First Name"
                  v-capitalizeName="firstName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="middleName"
                  label="Child Middle Name"
                  v-capitalizeName="middleName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Child Last Name"
                  v-capitalizeName="lastName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model.trim="email"
                  :error-messages="over18Rule"
                  label="E-Mail (Over Age 18 Only)"
                  v-if="!NA"
                  :ref="'childEmail' + childIndex.toString()"
                  v-on:keyup.enter="
                    gotoField('childDOB' + childIndex.toString(), $event)
                  "
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <!-- <v-menu
                  v-model="menu2small"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                 
                  ref="menu2small"
                >
                <template v-slot:activator="{ on }">-->
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2small = false"
                  v-if="!NA"
                  v-fixDate="birthdate"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  :ref="'childDOB' + childIndex.toString()"
                ></v-text-field>
                <!-- </template> -->
                <!-- <v-date-picker
                    no-title
                    v-model="parsedBirthdate"
                    :rules="[rules.required]"
                    scrollable
                    color="green"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @input="menu2small = false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="menu2small = false" :color="mainColor" dark>Cancel</v-btn>
                    <v-btn text @click="$refs.menu2small.save(birthdate)" :color="mainColor" dark>OK</v-btn>
                </v-date-picker>-->
                <!-- </v-menu> -->
              </v-flex>
              <v-flex xs12>
                <v-radio-group
                  v-model="sex"
                  row
                  label
                  v-if="!NA"
                  :rules="genderRules"
                >
                  <v-radio label="Male" value="M" :color="mainColor"></v-radio>
                  <v-radio
                    label="Female"
                    value="F"
                    :color="mainColor"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-container>
          </v-form>
        </template>
      </div>
    </div>
    <div v-else>
      <!-- if display employee -->
      <template v-if="isEmployee">
        <v-layout justify-center align-content-center>
          <v-subheader style="color: #00558c">
            <br />
            <br />Over the next few screens we will be asking questions about
            you and those you wish to seek coverage on (if applicable).
            <br />Please include any children you wish to cover on a child
            rider.
          </v-subheader>
        </v-layout>
        <br />
        <br />

        <v-form v-model="valid" :ref="personType + childIndex.toString()">
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs2>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="First Name"
                  v-capitalizeName="firstName"
                  ref="employeeName"
                  readonly
                  v-if="!isAgentApplication"
                ></v-text-field
                ><v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="First Name"
                  v-capitalizeName="firstName"
                  ref="employeeName"
                  v-if="isAgentApplication"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="middleName"
                  label="Middle Name"
                  v-capitalizeName="middleName"
                  readonly
                  v-if="!isAgentApplication"
                ></v-text-field
                ><v-text-field
                  v-model="middleName"
                  label="Middle Name"
                  v-capitalizeName="middleName"
                  v-if="isAgentApplication"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Last Name"
                  v-capitalizeName="lastName"
                  readonly
                  v-if="!isAgentApplication"
                ></v-text-field
                ><v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Last Name"
                  v-capitalizeName="lastName"
                  v-if="isAgentApplication"
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs6>
                <v-text-field
                  v-model.trim="street"
                  label="Residence Address"
                  :rules="residenceRules"
                  v-capitalize="street"
                  ref="empAddr"
                  v-on:keyup.enter="gotoField('empEmail', $event)"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row align-start>
              <v-flex xs2>
                <v-text-field
                  v-model.trim="homePhone"
                  label="Primary Phone"
                  :rules="phoneRules"
                  ref="empPhone"
                  v-on:keyup.enter="gotoField('empWrkPhone', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  v-model.trim="workPhone"
                  label="Work Phone"
                  :rules="phoneRules2"
                  ref="empWrkPhone"
                  v-on:keyup.enter="gotoField('empCity', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs3>
                <v-text-field
                  v-model.trim="city"
                  label="City"
                  :rules="cityRules"
                  v-capitalize="city"
                  ref="empCity"
                  v-on:keyup.enter="gotoField('empState', $event)"
                ></v-text-field>
              </v-flex>

              <v-flex xs3>
                <v-select
                  v-model="state"
                  :items="states"
                  menu-props="auto"
                  label="Select State"
                  single-line
                  attach
                  :rules="stateRules"
                  ref="empState"
                  v-on:blur="gotoField('zipEmp', $event)"
                ></v-select>
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  ref="zipEmp"
                  v-model.trim="zip"
                  :rules="zipRules"
                  label="ZIP"
                  v-on:keyup.enter="gotoField('empDOB', $event)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model.trim="email"
                      :rules="emailRules"
                      label="E-Mail"
                      v-on="on"
                      ref="empEmail"
                      v-on:keyup.enter="gotoField('empPhone', $event)"
                    ></v-text-field>
                  </template>
                  <span>Documents will be sent to the e-mail provided.</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs3>
                <!-- <v-dialog ref="dialog" v-model="modal" persistent full-width width="290px"> -->
                <!-- <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  ref="menu2"
                >-->
                <!-- <template v-slot:activator="{ on }"> -->
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2 = false"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  ref="empDOB"
                  v-fixDate="birthdate"
                  readonly
                  v-if="!isAgentApplication"
                ></v-text-field>
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2 = false"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  ref="empDOB"
                  v-fixDate="birthdate"
                  v-if="isAgentApplication"
                ></v-text-field>
                <!-- </template> -->
                <!-- <v-date-picker
                    no-title
                    v-model="parsedBirthdate"
                    :rules="[rules.required]"
                    scrollable
                    color="green"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @input="menu2 = false"
                  >
                   <v-spacer></v-spacer>
                    <v-btn text @click="menu2 = false" :color="mainColor" dark>Cancel</v-btn>
                    <v-btn text @click="$refs.menu2.save(birthdate)" :color="mainColor" dark>OK</v-btn>
                </v-date-picker>-->
                <!-- </v-menu> -->
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs4>
                <v-radio-group
                  v-model="sex"
                  row
                  label
                  :rules="genderRules"
                  ref="empSex"
                  v-on:keyup.tab.enter="gotoField('empEmployerName', $event)"
                >
                  <v-radio label="Male" value="M" :color="mainColor"></v-radio>
                  <v-radio
                    label="Female"
                    value="F"
                    :color="mainColor"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-spacer></v-spacer>
            <br />

            <v-flex xs12>
              <v-layout row align-start>
                <v-flex xs4>
                  <v-text-field
                    v-model.trim="employer"
                    label="Employer"
                    ref="empEmployerName"
                    disabled="disabled"
                    v-on:keyup.enter="gotoField('empEmployerCity', $event)"
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs3>
                  <v-text-field
                    v-model.trim="employerCity"
                    label="Employer's City"
                    :rules="employerCityRules"
                    v-capitalize="employerCity"
                    ref="empEmployerCity"
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs3>
                  <v-select
                    v-model="employerState"
                    :items="states"
                    menu-props="auto"
                    label="Select Employer State"
                    single-line
                    attach
                    disabled="disabled"
                    :rules="employerStateRules"
                    ref="empEmployerState"
                    v-on:blur="gotoBeneRadioBtns($event)"
                  ></v-select>
                  <!-- <v-select
                    v-model="employerState"
                    :items="states"
                    menu-props="auto"
                    label="Select Employer State"
                    single-line
                    attach
                    v-if="isAgentApplication"
                    :rules="employerStateRules"
                    ref="empEmployerState"
                    v-on:blur="gotoBeneRadioBtns($event)"
                  ></v-select> -->
                </v-flex>
                <v-spacer></v-spacer>
                <br />
                <br />
                <br />
              </v-layout>
            </v-flex>

            <v-layout row align-start>
              <v-flex xs4>
                <v-layout justify-right>
                  <v-radio-group
                    v-model="beneRadioBtn"
                    row
                    label="Beneficiary"
                    ref="beneEmployee"
                    :rules="otherBeneRules"
                    v-on:keyup.tab.enter="
                      gotoNextFieldBene('otherBene', $event)
                    "
                  >
                    <v-radio
                      label="Spouse"
                      value="spouse"
                      :color="mainColor"
                      ref="spouseBeneLabel"
                    ></v-radio>
                    <v-radio
                      label="Other"
                      value="other"
                      :color="mainColor"
                      ref="otherBeneLabel"
                    ></v-radio>
                  </v-radio-group>
                </v-layout>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs6>
                <v-text-field
                  v-model.trim="otherBene"
                  :error-messages="otherBeneRule"
                  label="Other Beneficiary"
                  :disabled="beneRadioBtn === 'spouse'"
                  ref="otherBene"
                ></v-text-field>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>

            <br />
            <br />
          </v-container>
        </v-form>
      </template>
      <!-- if display spouse -->
      <template v-else-if="isSpouse">
        <v-form v-model="valid" :ref="personType + childIndex.toString()">
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs12>
                <v-subheader style="color: #00558c">
                  <v-layout justify-center align-center
                    >Please enter your spouse's information, if
                    applicable.</v-layout
                  >
                </v-subheader>
                <v-checkbox
                  v-model="NA"
                  label="Not Applicable"
                  :color="mainColor"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs6>
                <v-text-field
                  v-model.trim="name"
                  :rules="nameRules"
                  label="Spouse's Full Name"
                  v-if="!NA"
                  v-capitalizeName="name"
                  ref="spouseName"
                  v-on:keyup.enter="gotoField('spouseEmail', $event)"
                ></v-text-field>
              </v-flex>-->

              <v-flex xs2>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="First Name"
                  v-capitalizeName="firstName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="middleName"
                  label="Middle Name"
                  v-capitalizeName="middleName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Last Name"
                  v-capitalizeName="lastName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  v-model.trim="email"
                  :rules="emailRules"
                  label="E-Mail"
                  v-if="!NA"
                  ref="spouseEmail"
                  v-on:keyup.enter="gotoField('spouseDOB', $event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <!-- <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  v-if="!NA"
                  ref="menu2"
                >
                <template v-slot:activator="{ on }">-->
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2 = false"
                  @keypress="isDateChar($event)"
                  maxlength="10"
                  v-if="!NA"
                  ref="spouseDOB"
                  v-fixDate="birthdate"
                ></v-text-field>
                <!-- </template> -->
                <!-- <v-date-picker
                    no-title
                    v-model="parsedBirthdate"
                    :rules="[rules.required]"
                    scrollable
                    color="green"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @input="menu2 = false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="menu2 = false" :color="mainColor" dark>Cancel</v-btn>
                    <v-btn text @click="$refs.menu2.save(birthdate)" :color="mainColor" dark>OK</v-btn>
                </v-date-picker>-->
                <!-- </v-menu> -->
              </v-flex>
              <v-flex xs6>
                <v-radio-group
                  v-model="sex"
                  row
                  label
                  v-if="!NA"
                  :rules="genderRules"
                  ref="spouseSex"
                >
                  <v-radio label="Male" value="M" :color="mainColor"></v-radio>
                  <v-radio
                    label="Female"
                    value="F"
                    :color="mainColor"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </template>
      <!-- if display child -->
      <template v-else-if="isChild">
        <v-form v-model="valid" :ref="personType + childIndex.toString()">
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs12>
                <v-subheader style="color: #00558c">
                  <v-layout justify-center align-center
                    >Please enter your child's information, if
                    applicable.</v-layout
                  >
                </v-subheader>

                <v-checkbox
                  v-model="NA"
                  label="Not Applicable"
                  :color="mainColor"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs6>
                <v-text-field
                  v-model.trim="name"
                  :rules="nameRules"
                  label="Child's Full Name"
                  v-if="!NA"
                  v-capitalizeName="name"
                  :ref="'childName'+childIndex.toString()"
                  v-on:keyup.enter="gotoField('childEmail' + childIndex.toString(), $event)"
                ></v-text-field>
              </v-flex>-->

              <v-flex xs2>
                <v-text-field
                  v-model="firstName"
                  :rules="firstNameRules"
                  label="First Name"
                  v-capitalizeName="firstName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="middleName"
                  label="Middle Name"
                  v-capitalizeName="middleName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="lastName"
                  :rules="lastNameRules"
                  label="Last Name"
                  v-capitalizeName="lastName"
                  v-if="!NA"
                  >></v-text-field
                >
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  v-model.trim="email"
                  :error-messages="over18Rule"
                  label="E-Mail (Over Age 18 Only)"
                  v-if="!NA"
                  :ref="'childEmail' + childIndex.toString()"
                  v-on:keyup.enter="
                    gotoField('childDOB' + childIndex.toString(), $event)
                  "
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <!-- <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  v-if="!NA"
                  ref="menu2"
                >
                <template v-slot:activator="{ on }">-->
                <v-text-field
                  v-model="birthdate"
                  :rules="birthdateRules"
                  label="Date of Birth"
                  hint="MM/DD/YYYY format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="parsedBirthdate = parseDate(birthdate)"
                  @input="menu2 = false"
                  v-fixDate="birthdate"
                  @keypress="isDateChar($event)"
                  v-if="!NA"
                  maxlength="10"
                  :ref="'childDOB' + childIndex.toString()"
                ></v-text-field>
                <!-- </template> -->
                <!-- <v-date-picker
                    no-title
                    v-model="parsedBirthdate"
                    :rules="[rules.required]"
                    scrollable
                    color="green"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @input="menu2 = false"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="menu2 = false" :color="mainColor" dark>Cancel</v-btn>
                    <v-btn text @click="$refs.menu2.save(birthdate)" :color="mainColor" dark>OK</v-btn>
                </v-date-picker>-->
                <!-- </v-menu> -->
              </v-flex>
              <v-flex xs6>
                <v-radio-group
                  v-model="sex"
                  row
                  label
                  v-if="!NA"
                  :rules="genderRules"
                >
                  <v-radio label="Male" value="M" :color="mainColor"></v-radio>
                  <v-radio
                    label="Female"
                    value="F"
                    :color="mainColor"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </template>
    </div>
  </div>
</template>

<script>
import statesList from '../data/states-list.js'
import eventBus from '../event-bus.js'
import store from '../store.js'
import { log } from '../http-common.js'

export default {
  name: 'tmkDemographics',
  props: {
    personType: String,
    person: Object,
    childIndex: Number,
    index: Number,
    mainColor: String,
    entity: Object,
  },
  components: {
    errorDialog: () => import(/* webpackPrefetch: true */ './error-dialog.vue'),
  },
  computed: {
    isAgentApplication() {
      if (
        this.$store.state.lpbAgent &&
        this.$store.state.lpbAgent.AgentNumber &&
        this.$store.state.lpbAgent.AgentNumber != ''
      )
        return true

      return false
    },
    individual() {
      // return an individual

      return {
        type: this.personType,
        firstName: this.firstName,
        lastName: this.lastName,
        middleName: this.middleName,
        name:
          this.firstName +
          ' ' +
          (this.middleName == '' ? '' : this.middleName + ' ') +
          this.lastName,
        email: this.email,
        sex: this.sex,
        street: this.street,
        city: this.city,
        state: this.state,
        zip: this.zip,
        birthdate: this.birthdate,
        parsedBirthdate: this.parsedBirthdate,
        beneRadioBtn: this.beneRadioBtn,
        applicable: !this.NA,
        childIndex: this.childIndex,
        age: this.age,
        ageInDays: this.ageInDays,
        employer: this.employer,
        employerCity: this.employerCity,
        employerState: this.employerState,
        homePhone: this.$options.filters.phone(this.homePhone),
        workPhone: this.$options.filters.phone(this.workPhone),
        otherBene: this.otherBene,
        id: this.uniqueId,
      }
    },

    age() {
      // calculate age from birthday
      try {
        let age = 0

        if (this.birthdate) {
          let DOBDate = this.parseDate(this.birthdate)

          if (DOBDate) {
            let DOB = new Date(DOBDate + 'T00:00:00')
            let today = new Date()

            age = today.getFullYear() - DOB.getFullYear()
            var monthsDiff = today.getMonth() - DOB.getMonth()
            if (
              monthsDiff < 0 ||
              (monthsDiff == 0 && today.getDate() < DOB.getDate())
            ) {
              age--
            }
          }
        }

        return age
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue age')
        return 0
      }
    },
    ageInDays() {
      try {
        let ageInDays = 0
        let ageInYears = 0

        if (this.birthdate) {
          let DOBDate = this.parseDate(this.birthdate)

          if (DOBDate) {
            let DOB = new Date(DOBDate + 'T00:00:00')
            let today = new Date()
            today.setHours(0, 0, 0, 0)

            ageInYears = today.getFullYear() - DOB.getFullYear()
            var monthsDiff = today.getMonth() - DOB.getMonth()
            if (
              monthsDiff < 0 ||
              (monthsDiff == 0 && today.getDate() < DOB.getDate())
            ) {
              ageInYears--
            }

            if (ageInYears >= 1) {
              ageInDays = undefined
            } else {
              var oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
              ageInDays = Math.round(
                Math.abs((today.getTime() - DOB.getTime()) / oneDay)
              )
            }
          }
        } else {
          ageInDays = undefined
        }

        return ageInDays
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue ageInDays')
        return 0
      }
    },
    over18Rule: function () {
      try {
        if (this.individual.age >= 18 && (!this.email || this.email == '')) {
          return 'E-mail is required for children over 18.'
        }

        if (this.email != '' && !/.+@.+\..+/.test(this.email)) {
          return 'E-mail must be valid.'
        }

        return ''
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue over18Rule')
        return ''
      }
    },
    isEmployee() {
      return this.personType === 'employee'
    },
    isSpouse() {
      return this.personType === 'spouse'
    },
    isChild() {
      return this.personType === 'child'
    },
    otherBeneRule: function () {
      if (
        this.beneRadioBtn.toLowerCase() === 'spouse' ||
        this.beneRadioBtn.toLowerCase() === ''
      ) {
        return ''
      }
      if (this.otherBene === null || this.otherBene === '') {
        return 'Please complete the other beneficiary field.'
      }
      return ''
    },
  },

  created() {
    try {
      if (this.isAgentApplication) {
        this.employer = this.$store.state.lpb.lpb_name
        this.employerCity = this.$store.state.lpb.city
        this.employerState = this.$store.state.lpb.state = 'New Mexico'
      }

      if (this.person) {
        this.NA = !this.person.applicable
        this.type = this.person.type
        this.name = this.person.name
        this.firstName = this.person.firstName
        this.middleName = this.person.middleName
        this.lastName = this.person.lastName
        this.sex = this.person.sex
        this.email = this.person.email
        this.street = this.person.street
        this.city = this.person.city
        this.state = this.person.state
        this.zip = this.person.zip
        this.birthdate = this.person.birthdate
        this.parsedBirthdate = this.person.parsedBirthdate
        this.beneRadioBtn = this.person.beneRadioBtn
        this.employer = this.person.employer
        this.employerCity = this.person.employerCity
        this.employerState = this.person.employerState
        this.homePhone = this.$options.filters.phone(this.person.homePhone)
        this.workPhone = this.$options.filters.phone(this.person.workPhone)
        this.otherBene = this.person.otherBene
        this.uniqueId = this.person.id ? this.person.id : this.uuid()

        eventBus.$emit('showAddBtn', this.person.applicable)
      } else {
        if (this.uniqueId === -1) this.uniqueId = this.uuid()

        if (this.isEmployee) {
          if (
            this.$store.state.employee &&
            this.$store.state.employee.LastName
          ) {
            let emp = this.$store.state.employee

            this.lastName = emp.LastName
            this.firstName = emp.FirstName
            this.middleName = emp.MiddleName
            this.birthdate =
              emp.DOB.length == 8
                ? emp.DOB.substr(4, 4) + emp.DOB.substr(0, 4)
                : ''
            this.employer =
              emp.AgencyName && emp.AgencyName != ''
                ? emp.AgencyName
                : this.employer
          }
        }

        eventBus.$emit('showAddBtn', true)
      }
    } catch (e) {
      log(e.toString(), true, 'alt-demographics.vue created')
      // console.log(e)
      this.errors.push(e)
      this.error = true
    }
  },
  watch: {
    parsedBirthdate() {
      try {
        this.birthdate = this.formatDate(this.parsedBirthdate)
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue parsedBirthdate')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
  },
  data: () => ({
    error: false,
    errors: [],
    states: statesList,
    modal: false,
    menu2: false,
    menu2small: false,
    valid: true,
    NA: false,
    beneRadioBtn: '',
    otherBene: '',
    otherBeneRules: [(v) => !!v || 'Beneficiary is required.'],
    name: '',
    nameRules: [
      (v) => !!v || 'Full name is required.',
      (v) => (v && v.length > 2) || 'Name must be more than 2 characters.',
    ],
    firstName: '',
    firstNameRules: [
      (v) => !!v || 'First name is required.',
      (v) => (v && v.length > 1) || 'First name must be at least 2 characters.',
    ],
    middleName: '',
    lastName: '',
    lastNameRules: [
      (v) => !!v || 'Last name is required.',
      (v) => (v && v.length > 1) || 'Last name must be at least 2 characters.',
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required.',
      (v) =>
        /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
          v.trim()
        ) || 'E-mail must be valid',
      //v => /.+@.+\.{1}.+/.test(v) || 'E-mail must be valid'
    ],
    rules: {},
    street: '',
    residenceRules: [(v) => !!v || 'Residence address is required.'],
    city: '',
    cityRules: [(v) => !!v || 'City is required.'],
    state: '',
    stateRules: [(v) => !!v || 'State is required.'],
    zip: '',
    // zip must be 5 digits, 9 digits, or 5 dash 4 digits
    zipRules: [
      (v) =>
        /^\d{5}$/.test(v) ||
        /^\d{9}$/.test(v) ||
        /^\d{5}-\d{4}$/.test(v) ||
        'Zip code must be 5 or 9 digits.',
    ],
    beneficiary: '',
    sex: '',
    genderRules: [(v) => !!v || 'Please select a gender.'],
    birthdate: null,
    parsedBirthdate: null,
    birthdateRules: [
      (v) => !!v || 'Birthdate is required.',
      (v) =>
        /^\d{2}\/\d{2}\/\d{4}/.test(v) ||
        'Please enter the birthdate in MM/DD/YYYY format.',
      (v) => {
        if (v) {
          const [month, day, year] = v.split('/')
          if (year && month && day) {
            let dob = `${year}-${month.padStart(2, '0')}-${day.padStart(
              2,
              '0'
            )}`

            if (new Date(dob + 'T00:00:00') == 'Invalid Date') {
              return 'Birthdate must be valid.'
            } else if (
              new Date(dob + 'T00:00:00') < new Date('1900-01-01T00:00:00')
            ) {
              return 'Birthdate cannot fall before January 1, 1900.'
            } else
              return (
                new Date(dob + 'T00:00:00') <= new Date() ||
                'Birthdate cannot be in the future.'
              )
          } else {
            return 'Please enter the birthdate in MM/DD/YYYY format.'
          }
        } else {
          return 'Birthdate is required.'
        }
      },
    ],
    insuranceInfo: {},
    employer: 'State of New Mexico', // to do - get from url
    employerRules: [(v) => !!v || 'Employer name is required.'],
    employerCity: '',
    employerCityRules: [(v) => !!v || "Please enter the employer's city."],
    employerState: 'New Mexico', // to do - get from url
    employerStateRules: [(v) => !!v || "Please enter the employer's state."],
    homePhone: '',
    workPhone: '',
    phoneRules: [
      (v) => !!v || 'Primary phone number is required',

      (v) =>
        /^[\d{1}]?[ ]?[.\-( ]?[ ]?\d{3}[ ]?[.\-) ]?[ ]?\d{3}[.\- ]?\d{4}[ ]*$/.test(
          v
        ) || 'Please enter a valid phone number with area code.',
    ],
    phoneRules2: [
      (v) =>
        !v ||
        /^[\d{1}]?[ ]?[.\-( ]?[ ]?\d{3}[ ]?[.\-) ]?[ ]?\d{3}[.\- ]?\d{4}[ ]*$/.test(
          v
        ) ||
        'Please enter a valid phone number with area code.',
    ],
    uniqueId: -1,
  }),
  methods: {
    isDateChar($event) {
      try {
        let charCode = $event.keyCode ? $event.keyCode : $event.which
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 47
        ) {
          $event.preventDefault()
        }
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue isDateChar')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    uuid() {
      try {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
          /[xy]/g,
          function (c) {
            let r = (Math.random() * 16) | 0,
              v = c == 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
          }
        )
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue uuid')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    gotoNextFieldBene(otherBene, event) {
      if (this.beneRadioBtn.toLowerCase() === 'other') {
        this.gotoField(otherBene, event)
      }
    },
    gotoField(refId, event) {
      try {
        if (event) {
          event.preventDefault()
        }
        this.$refs[refId].focus()
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue gotoField')
        return
      }
    },
    gotoBeneRadioBtns(e) {
      try {
        let label = 'otherBeneLabel'

        if (
          this.beneRadioBtn === undefined ||
          this.beneRadioBtn === '' ||
          this.beneRadioBtn === 'spouse'
        ) {
          label = 'spouseBeneLabel'
        }

        this.$refs[label].$el.children[0].children[0].focus()

        if (e) {
          e.preventDefault()
        }
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue gotoBeneRadioBtns')
        return
      }
    },
    formatDate(date) {
      try {
        if (!date) {
          date = new Date().toISOString().substr(0, 10)
        }

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue formatDate')
        return ''
      }
    },
    parseDate(date) {
      try {
        if (!date) return null

        if (!/^\d{2}\/\d{2}\/\d{4}/.test(date)) return null

        const [month, day, year] = date.split('/')

        if (!year || !month || !day) return null

        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue parseDate')
        return ''
      }
    },
    save(step) {
      try {
        if (step.indexOf('leaving') >= 0) {
          if (
            this.individual.type == 'child' ||
            this.individual.type == 'spouse'
          ) {
            if (
              this.individual.lastName == '' &&
              this.individual.firstName == ''
            )
              return
            else this.$store.commit('setDemographicsPage', this.index)
          } else this.$store.commit('setDemographicsPage', this.index)
        }
        // does the individual exist in the store?
        let person = store.getters.getIndividualByTypeAndChildIndex(
          this.individual.type,
          this.individual.childIndex
        )

        if (
          person === undefined &&
          (this.individual.type === 'spouse' || this.individual.applicable)
        ) {
          // new individual, push into the store array
          store.commit('addIndividual', this.individual)

          if (
            this.isAgentApplication &&
            (this.individual.type == 'employee' ||
              this.individual.type == 'applicant')
          ) {
            this.$store.commit('setEmployeeName', {
              firstName: this.individual.firstName,
              middleName: this.individual.middleName,
              lastName: this.individual.lastName,
            })
            this.$store.commit(
              'setEmployeeDOB',
              this.individual.birthdate.substr(6, 4) +
                this.individual.birthdate.substr(0, 2) +
                this.individual.birthdate.substr(3, 2)
            )
          }
        } else if (
          person === undefined &&
          this.individual.type === 'child' &&
          !this.individual.applicable &&
          step === 'next'
        ) {
          this.NA = false
          return
        } else if (person != undefined) {
          // the individual exists in the store already, update the array
          if (this.individual.type === 'child' && !this.individual.applicable) {
            store.commit('removeIndividual', this.individual)
          } else {
            store.commit('updateIndividual', this.individual)

            if (
              this.isAgentApplication &&
              (this.individual.type == 'employee' ||
                this.individual.type == 'applicant')
            ) {
              this.$store.commit('setEmployeeName', {
                firstName: this.individual.firstName,
                middleName: this.individual.middleName,
                lastName: this.individual.lastName,
              })
              this.$store.commit(
                'setEmployeeDOB',

                this.individual.birthdate.substr(6, 4) +
                  this.individual.birthdate.substr(0, 2) +
                  this.individual.birthdate.substr(3, 2)
              )
            }
          }
        }

        // reply back with success so the tmk-proposed-insureds component knows it can move on
        eventBus.$emit('individualSaved')
      } catch (e) {
        log(e.toString(), true, 'alt-demographics.vue save')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
  },
  beforeDestroy() {
    try {
      eventBus.$off('savePerson')
      eventBus.$off('resetValidation')
    } catch (e) {
      log(e.toString(), true, 'alt-demographics.vue beforeDestroy')
      return
    }
  },

  mounted() {
    try {
      if (this.isAgentApplication) {
        if (this.employer != this.$store.state.lpb.lpb_name) {
          this.employer = this.$store.state.lpb.lpb_name
          this.employerCity = this.$store.state.lpb.city
          this.employerState = this.$store.state.lpb.state = 'New Mexico'
        }
      }

      if (this.$store.state.demographicsPage) {
        this.e1 = this.$store.state.demographicsPage
      }

      eventBus.$on(
        'savePerson',
        function () {
          this.save('leaving route')
        }.bind(this)
      ),
        eventBus.$on(
          'resetValidation',
          function (idx) {
            if (this.index === idx) {
              if (this.$refs[this.personType + this.childIndex.toString()]) {
                this.$refs[
                  this.personType + this.childIndex.toString()
                ].resetValidation()
              }
            }
          }.bind(this)
        )
      // handle the validate and save request from tmk-proposed-insureds
      eventBus.$on(
        'validateAndSaveInd',
        function (idx, step) {
          // ensure the correct form is replying to the event
          if (this.index === idx) {
            // make sure the form reference exists
            if (this.$refs[this.personType + this.childIndex.toString()]) {
              // validate the form by its reference

              if (
                this.$refs[
                  this.personType + this.childIndex.toString()
                ].validate()
              ) {
                // if this is a child demographic, also make sure the over 18 rule passes
                if (this.childIndex >= 0 && this.over18Rule === '') {
                  // save the child to the store

                  this.save(step)
                } else if (this.childIndex >= 0) {
                  eventBus.$emit('invalidEntries')
                } else if (this.childIndex < 0) {
                  // save the employee/spouse to the store

                  if (this.personType === 'employee') {
                    // check for the other beneficiary, if required, before saving employee

                    if (this.otherBeneRule === '') {
                      this.save(step)
                    } else {
                      eventBus.$emit('invalidEntries')
                    }
                  } else {
                    // save spouse to the store
                    this.save(step)
                  }
                }
              } else {
                eventBus.$emit('invalidEntries')
              }
            }
          }
        }.bind(this)
      )
    } catch (e) {
      log(e.toString(), true, 'alt-demographics.vue mounted')
      // console.log(e)
      this.errors.push(e)
      this.error = true
    }
  },
}
</script>
<style scoped>
.commonFont {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  color: gray;
  text-align: left;
  font-weight: 500;
  height: 48px;
  padding: 0 16px;
}
</style>